<template>
    <div class="bs-list">
        <el-row>
            <el-col :span="12">
                <div class="bs-list-item">
                    <div class="bs-list-item-lable">单位：</div>
                    <div class="bs-list-item-content">{{ balanceDetail.organizationCompanyName }}</div>
                </div>
                <div class="bs-list-item">
                    <div class="bs-list-item-lable">类型：</div>
                    <div class="bs-list-item-content">余额</div>
                </div>
                <div class="bs-list-item">
                    <div class="bs-list-item-lable">应付账款：</div>
                    <el-tooltip class="bs-list-item-tip" effect="dark" content="点击展示明细" placement="top-start" :enterable="false">
                        <div class="bs-list-item-content under-line" @click="billingDialog(1)">{{ balanceDetail.originalApscAmt }}</div>
                    </el-tooltip>
                </div>
                <div class="bs-list-item">
                    <div class="bs-list-item-lable">其他应付款-押金：</div>
                    <el-tooltip class="bs-list-item-tip" effect="dark" content="点击展示明细" placement="top-start" :enterable="false">
                        <div class="bs-list-item-content under-line" @click="billingDialog(2)">{{ balanceDetail.originalOtherApDeposit }}</div>
                    </el-tooltip>
                </div>
                <div class="bs-list-item">
                    <div class="bs-list-item-lable">预付账款：</div>
                    <el-tooltip class="bs-list-item-tip" effect="dark" content="点击展示明细" placement="top-start" :enterable="false">
                        <div class="bs-list-item-content under-line" @click="billingDialog(3)">{{ balanceDetail.originalPrepaymentAmt }}</div>
                    </el-tooltip>
                </div>
                <div class="bs-list-item">
                    <div class="bs-list-item-lable">其他应收款-押金：</div>
                    <el-tooltip class="bs-list-item-tip" effect="dark" content="点击展示明细" placement="top-start" :enterable="false">
                        <div class="bs-list-item-content under-line" @click="billingDialog(4)">{{ balanceDetail.originalOtherArDeposit }}</div>
                    </el-tooltip>
                </div>
                <div class="bs-list-item">
                    <div class="bs-list-item-lable">期末余额：</div>
                    <div class="bs-list-item-content">{{ balanceDetail.originalApSumAmt }}</div>
                </div>
                <div class="bs-list-item">
                    <div class="bs-list-item-lable">调整项小计：</div>
                    <div class="bs-list-item-content">{{ adjustmentOne.adjustmentTotalAmt }}</div>
                </div>
                <div class="leave-note">站个坑</div>
                <div class="bs-add-types">
                    <div class="bs-add-types-item" v-for="(item, index) in AdjustmentArrayOne" :key="index">
                        <div class="bs-add-types-item-lable">
                            <div>{{item.adjustmentContent}}</div>
                        </div>
                        <div class="bs-add-types-item-content">
                            <div>{{item.adjustmentAmt}}</div>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="12">
                <div class="bs-list-item">
                    <div class="bs-list-item-lable">单位：</div>
                    <div class="bs-list-item-content">{{ balanceDetail.supName }}</div>
                </div>
                <div class="bs-list-item">
                    <div class="bs-list-item-lable">类型：</div>
                    <div class="bs-list-item-content">余额</div>
                </div>
                <div class="bs-list-item">
                    <div class="bs-list-item-lable">应收账款：</div>
                    <div :class="[balanceDetail.replyApscAmt !== balanceDetail.originalApscAmt ? 'bs-list-item-redcontent' : 'bs-list-item-content']">
                        <el-input type="text" v-model="balanceDetail.replyApscAmt" :disabled="isConfirmFlag"
                            v-input-limit='2' placeholder="请输入应付账款"></el-input>
                    </div>
                </div>
                <div class="bs-list-item">
                    <div class="bs-list-item-lable">其他应收款-押金：</div>
                    <div :class="[balanceDetail.replyOtherApDeposit !== balanceDetail.originalOtherApDeposit ? 'bs-list-item-redcontent' : 'bs-list-item-content']">
                        <el-input type="text" v-model="balanceDetail.replyOtherApDeposit" :disabled="isConfirmFlag"
                            v-input-limit='2' placeholder="请输入其他应付款-押金"></el-input>
                    </div>
                </div>
                <div class="bs-list-item">
                    <div class="bs-list-item-lable">预收账款：</div>
                    <div :class="[balanceDetail.replyPrepaymentAmt !== balanceDetail.originalPrepaymentAmt ? 'bs-list-item-redcontent' : 'bs-list-item-content']">
                        <el-input type="text" v-model="balanceDetail.replyPrepaymentAmt" :disabled="isConfirmFlag"
                            v-input-limit='2' placeholder="请输入预付账款"></el-input>
                    </div>
                </div>
                <div class="bs-list-item">
                    <div class="bs-list-item-lable">其他应付款-押金：</div>
                    <div :class="[balanceDetail.replyOtherArDeposit !== balanceDetail.originalOtherArDeposit ? 'bs-list-item-redcontent' : 'bs-list-item-content']">
                        <el-input type="text" v-model="balanceDetail.replyOtherArDeposit" :disabled="isConfirmFlag"
                            v-input-limit='2' placeholder="请输入其他应收款-押金"></el-input>
                    </div>
                </div>
                <div class="bs-list-item">
                    <div class="bs-list-item-lable">期末余额：</div>
                    <div class="bs-list-item-content">{{ balanceDetail.replyAdjustTotalAmt }}</div>
                </div>
                <div class="bs-list-item">
                    <div class="bs-list-item-lable">调整项小计：</div>
                    <div class="bs-list-item-content">{{ adjustmenttwo.adjustmentTotalAmt }}</div>
                </div>
                <div class="bs-add-btn">
                    <!-- <el-button type="primary" @click="addAdjustmentTwo" :disabled="isSaveFlag">新增</el-button> -->
                    <el-dropdown @command="handleCommand" trigger="click">
                        <el-button type="primary" :disabled="isSaveFlag">
                            新增<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown" :disabled="isSaveFlag">
                            <el-dropdown-item v-for="(v, i) in adjustmentListTwo" :key="i" :command="v">{{v.name}}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button type="primary" @click="saveAdjustmentTwo"
                        :disabled="isSaveFlag || AdjustmentArrayTwo.length === 0">保存
                    </el-button>
                    <el-button type="primary" v-has="'07060003'" :disabled="isFildUplodFlag" @click="fileUpload">
                        上传调整项明细附件</el-button>
                </div>
                <div class="bs-add-types">
                    <div class="bs-add-types-item" v-for="(item, index) in AdjustmentArrayTwo" :key="index">
                        <div class="bs-add-types-item-lable">
                            <div>{{item.adjustmentContent}}</div>
                        </div>
                        <div class="bs-add-types-item-content">
                            <el-input v-model="item.adjustmentAmt"
                                @keyup.native="item.adjustmentAmt = item.adjustmentAmt.replace(item.adjustmentAmt, RestrictedMoney(item.adjustmentAmt))"
                                @change="materielExtraCostChange(item.adjustmentAmt, index)" @input="inputChange"
                                :disabled="isSaveFlag" placeholder="请输入调整项金额">
                            </el-input>
                            <div class="bs-add-types-item-operate">
                                <el-button type="danger" plain size="mini" :disabled="isSaveFlag"
                                    @click="deleteAdjustmentTwo(item, index)">删除
                                </el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <div class="bs-adjusted">
                    <div class="bs-adjusted-lable">调整后余额：</div>
                    <div class="bs-adjusted-content">{{ leftBalance }}</div>
                </div>
            </el-col>
            <el-col :span="12">
                <div class="bs-adjusted">
                    <div class="bs-adjusted-lable">调整后余额：</div>
                    <div class="bs-adjusted-content">{{ rightBalance }}</div>
                </div>
            </el-col>
        </el-row>
        <div class="bs-main">
            <el-row>
                <el-col :span="12">
                    <div class="bs-main-info bs-stamp">
                        <div class="bs-main-info-lable">对账人：</div>
                        <div class="bs-main-info-content">{{ balanceDetail.handlerName }}</div>
                    </div>
                    <div class="bs-main-info">
                        <div class="bs-main-info-lable">对账时间：</div>
                        <div class="bs-main-info-content">{{ balanceDetail.endAccountCycleDate }}</div>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="bs-main-info bs-stamp">
                        <div class="bs-main-info-lable">对账单位（签字盖章）：</div>
                        <div class="bs-main-info-content"></div>
                    </div>
                    <div class="bs-main-info">
                        <div class="bs-main-info-lable">对账日期：</div>
                        <div class="bs-main-info-content">{{ balanceDetail.accountDate }}</div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <balance-dril-dialog ref="balanceDialog" :pageTotal="pageTotal" :config="config" :totalData="totalData"
            :title="title" :currentPage="currentPage" @bsExport="banlnceSurveyExport" @sizeChange="sizeChange"
            @pageChange="pageChange" />
    </div>
</template>

<script>
import balanceDrilDialog from '../dialog/balanceDrilDialog';
import { plusOrMinus } from '../../../../utils/common';
import { getSupBalanceAccountList, saveApDealingsAdjustments, deleteApDealingsAdjustments, getExportTask } from '../../../../api/statement/statementApi';
const TENANT_CODE = 'annto';
const APPLICATION_NAME = 'LMS-BMS';
const requestResults = `截止会计期间,会计主体,供应商,分公司,服务平台,发票号,发票金额,发票余额,款项类别`;
const VUE_APP_ACCOUNT_CONVEY_CODE = 'dcd803cf-64fc-47c4-8562-870415d1f7ed';
export default {
    components: { balanceDrilDialog },
    props: {
        isConfirmFlag: Boolean,
        isSaveFlag: Boolean,
        isFildUplodFlag: Boolean,
        balanceDetail: {
            type: Object
        },
        adjustmentOne: {
            type: Object
        },
        adjustmenttwo: {
            type: Object
        }
    },
    data() {
        return {
            isDele: false,
            AdjustmentArrayOne: [],
            adjustmentListTwo: [
                { name: '应收账款', value: 1 },
                { name: '其他应收款-押金', value: 2 },
                { name: '预收账款', value: 3 },
                { name: '其他应付款-押金', value: 4 }
            ],
            AdjustmentArrayTwo: [],
            isAdloading: false,
            title: '',
            pageTotal: 0,
            totalData: [],
            fundType: '',
            currentPage: 1,
            config: {
                page: {
                    layout: 'total, sizes, prev, pager, next, jumper',
                    pageSize: 10,
                    pageNo: 1
                }
            }
        };
    },
    computed: {
        leftBalance() {
            // 将可能为 null/undefined 的值转换为数字（非数字转为0）
            const original = +this.balanceDetail.originalApSumAmt || 0;
            const adjustment = +this.adjustmentOne.adjustmentTotalAmt || 0;
            // 计算总和（保留两位小数，但返回数字类型）
            const sum = original + adjustment;
            // 使用 Number() 确保返回数字类型，避免字符串问题
            return Number(sum.toFixed(2));
        },
        rightBalance() {
            const replyAdjustTotalAmt = +this.balanceDetail.replyAdjustTotalAmt || 0;
            const adjustmentTotalAmt = +this.adjustmenttwo.adjustmentTotalAmt || 0;
            const sum = replyAdjustTotalAmt + adjustmentTotalAmt;
            return Number(sum.toFixed(2));
        }
    },
    methods: {
        addAdjustmentTwo() { // 右边新增
            this.AdjustmentArrayTwo.push({
                adjustmentContent: '',
                adjustmentAmt: '',
                dealingsBillNo: this.balanceDetail.dealingsBillNo,
                adjustmentType: 2
            });
        },
        saveAdjustmentTwo() { // 右边保存
            const saveFlag = this.AdjustmentArrayTwo.some(item => { return (item.adjustmentAmt === ''); });
            if (saveFlag) return this.$message.warning('新增调整项金额不能为空');
            const zeroVerify = this.AdjustmentArrayTwo.some(item => { return (item.adjustmentAmt === '0' || item.adjustmentAmt === 0); });
            if (zeroVerify) return this.$message.warning('调整金额不能为0');
            this.isAdloading = true;
            saveApDealingsAdjustments(this.AdjustmentArrayTwo).then(res => {
                if (res && +res.code === 0) {
                    this.isAdloading = false;
                    this.$message.success('保存成功');
                    this.$emit('getApAdjustmentTypeList', 2);
                }
            }).finally(() => { this.isAdloading = false; });
        },
        deleteAdjustmentTwo(e, index) { // 右边删除
            const deleteArr = []; deleteArr.push(e.jobId);
            if (e.jobId) {
                this.$confirm('您确定要删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteAdjustMe(deleteArr, 2);
                }).catch(() => { });
            } else {
                this.AdjustmentArrayTwo.splice(index, 1);
            }
        },
        deleteAdjustMe(deleteArr, type) { // 删除调整项小计
            this.isAdloading = true;
            deleteApDealingsAdjustments(deleteArr).then(res => {
                if (res && +res.code === 0) {
                    this.isAdloading = false;
                    this.$message.success('删除成功');
                    this.$emit('getApAdjustmentTypeList', type);
                }
            }).finally(() => { this.isAdloading = false; });
        },
        billingDialog(type) { // 往来明细余额下钻弹窗界面
            this.title = '往来明细余额下钻界面';
            this.$refs.balanceDialog.dialogVisible = true;
            this.config.page.pageNo = 1;
            this.totalData = [];
            this.getSupBalanceList(type);
        },
        getSupBalanceList(type) { // 往来明细余额下钻弹窗界面列表数据
            this.fundType = type;
            const params = {
                pageNo: this.config.page.pageNo,
                pageSize: this.config.page.pageSize,
                dealingsBillNo: this.$route.query.dealingsBillNo,
                fundType: type
            };
            this.currentPage = this.config.page.pageNo;
            this.$refs.balanceDialog.isDialogLoading = true;
            getSupBalanceAccountList(params).then(res => {
                if (res && +res.code === 0) {
                    this.$refs.balanceDialog.isDialogLoading = false;
                    this.totalData = res.data.list || [];
                    this.pageTotal = res.data.totalCount || 0;
                }
            }).finally(() => { this.$refs.balanceDialog.isDialogLoading = false; });
        },
        pageChange(data) {
            this.config.page.pageNo = data;
            this.getSupBalanceList(this.fundType);
        },
        sizeChange(data) {
            this.config.page.pageSize = data;
            this.getSupBalanceList(this.fundType);
        },
        banlnceSurveyExport(params) { // 往来明细余额具体账款明细导出
            const data = {
                applicationCode: 'APP202009170009',
                applicationName: APPLICATION_NAME,
                dealingsBillNo: this.balanceDetail.dealingsBillNo,
                tenantCode: TENANT_CODE,
                reportCode: VUE_APP_ACCOUNT_CONVEY_CODE,
                requestResults: requestResults,
                fundType: this.fundType
            };
            this.$refs.balanceDialog.isDialogLoading = true;
            getExportTask(data).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('导出成功，请在右上角的文件信息中下载');
                }
            }).finally(() => { this.$refs.balanceDialog.isDialogLoading = false; });
        },
        // 调整小计校验输入正负数， 保留2位小数 调用公共方法
        RestrictedMoney(values) {
            return plusOrMinus(values.toString());
        },
        // 结合change事件对失去焦点进行判断，防止输入一些无效值
        materielExtraCostChange(item, index) {
            // 防止删除为空
            if (!item) item = '0';
            // 一些错误金额输入的判断
            if (item.toString().indexOf('.') > 0 && Number(item.toString().split('.')[1].length) < 1) item = item.toString().split('.')[0];
            // 一些错误金额输入的判断
            if (!item || item === '-' || item === '-0') item = '0';
            item = parseFloat(item);
            this.AdjustmentArrayTwo[index].adjustmentAmt = item;
        },
        inputChange(value) {
            if (value.indexOf('.') !== -1 && value.split('.').length > 2) {
                return this.$message.warning('请输入正确格式的金额'); // 防止输入多个小数点或者'-'
            } else if (value.indexOf('-') !== -1 && value.split('-').length > 2) {
                return this.$message.warning('请输入正确格式的金额'); // 防止输入多个小数点或者'-'
            } else if (value.indexOf('.') !== -1 && value.split('.')[1].length > 2) {
                return this.$message.warning('请输入两位小数的金额'); // 小数点后两位
            }
        },
        fileUpload() {
            this.$emit('sureyFileUpload');
        },
        handleCommand(command) {
            const isChooseed = this.AdjustmentArrayTwo.some(item => item.adjustmentContent === command.name);
            if (isChooseed) return this.$message.warning(command.name + '已选择，不能重复新增');
            this.AdjustmentArrayTwo.push({
                adjustmentContent: command.name,
                adjustmentAmt: '',
                adjustmentContentType: command.value,
                dealingsBillNo: this.balanceDetail.dealingsBillNo,
                adjustmentType: 2
            });
        }
    },
    mounted() { },
    watch: {
        adjustmentOne: {
            handler(newName, oldName) {
                this.AdjustmentArrayOne = [...newName.efApDealingsAdjustmentList];
            },
            deep: true
        },
        adjustmenttwo: {
            handler(newName, oldName) {
                this.AdjustmentArrayTwo = [...newName.efApDealingsAdjustmentList];
            },
            deep: true
        }
    }
};
</script>

<style lang="less">
@import "./balanceSurvey.less";
</style>
